import { AnyAction } from 'redux';
import axios from 'axios';
import {
  deleteRequest,
  getRequest,
  postRequestFiles,
  postRequest,
} from 'src/services/requests';
import {
  AcompanhamentoDTO,
  ContatoDTO,
  TituloDTO,
} from '../types/dtos/genericos';
import { Acompanhamento } from '../types/genericos';

const getAcompanhamentos = (
  os: number,
  item: number,
  codigoEmpresa: string,
  tipo: string,
  embarquePedidoOc: string
): Promise<AcompanhamentoDTO[]> =>
  new Promise((resolve, reject) => {
    const data =
      tipo === 'S'
        ? {
            CodigoEmpresa: codigoEmpresa,
            ContatoOsLancNf: os,
            SequenciaItem: item,
            TipoAcompanhamento: tipo,
          }
        : {
            TipoAcompanhamento: tipo,
            EmbarquePedidoOc: embarquePedidoOc,
            ContatoOsLancNf: os,
            CodigoEmpresa: codigoEmpresa,
            SequenciaItem: item,
          };
    postRequest('genericos/ge/acompanhamentos/buscar', data, resolve, reject);
  });

const getContatosEmpresa = (empresa: string): Promise<ContatoDTO[]> =>
  new Promise((resolve, reject) => {
    getRequest(
      `genericos/ge/contato/Buscar?$filter=CodigoPessoa eq '${empresa}'`,
      resolve,
      reject
    );
  });

const getTituloAcompanhamento = (): Promise<TituloDTO[]> =>
  new Promise((resolve, reject) => {
    getRequest('genericos/ge/TituloAcompanhamento/Buscar', resolve, reject);
  });

const hasCredencialEmail = (): Promise<AnyAction> =>
  new Promise((resolve, reject) => {
    getRequest('genericos/ge/email/HasCredencialEmail', resolve, reject);
  });

const montaTituloAcompanhamento = (
  CodigoEmpresa: string,
  TipoAcompanhamento: string,
  CodigoOrdemServico: number,
  Sequencia: number,
  EmbarquePedidoOc: string
): Promise<{
  data: [{ Titulo: string; Subtitulo: string; Tooltip: string }];
}> => {
  return new Promise((resolve, reject) => {
    postRequest(
      'genericos/ge/acompanhamentos/MontarTituloAcompanhamento',
      {
        CodigoEmpresa,
        TipoAcompanhamento,
        CodigoOrdemServico,
        Seq: Sequencia,
        EmbarquePedidoOc,
      },
      resolve,
      reject
    );
  });
};

const salvarContato = (
  Contato: string,
  CodigoEmpresa: string,
  Email: string,
  Celular: string,
  Sequencia: number | null,
  RecebeCartaCobranca: boolean
): Promise<any> => {
  return new Promise((resolve, reject) => {
    postRequest(
      'genericos/ge/contato/Salvar',
      {
        Contato,
        CodigoEmpresa,
        Email,
        Celular,
        Sequencia,
        RecebeCartaCobranca,
      },
      resolve,
      reject
    );
  });
};

const validarUrl = (
  Url: string
): Promise<{
  messages: string[];
  success: boolean;
}> => {
  return new Promise((resolve, reject) => {
    getRequest(
      `genericos/ge/acompanhamentos/ValidarUrl?Url=${Url}`,
      resolve,
      reject
    );
  });
};

const getContatosBloqueados = (listaEmails: string): Promise<any> =>
  new Promise((resolve, reject) => {
    getRequest(
      `genericos/ge/contatobloqueado/buscar?$select=Email&$filter=Email in (${listaEmails})`,
      resolve,
      reject
    );
  });

const salvarAnexo = (
  url: string,
  data: FormData
): Promise<{
  success: {
    Code: number;
    Message: string;
  };
}> => {
  return new Promise((resolve, reject) => {
    postRequestFiles(url, data, resolve, reject);
  });
};

const excluirAnexo = (url: string): Promise<any> =>
  new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(response => {
        const { data } = response;

        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });

const criarAcompanhamento = (
  acompanhamento: Acompanhamento
): Promise<{
  data: [{ Titulo: string; Subtitulo: string; Tooltip: string }];
}> => {
  return new Promise((resolve, reject) => {
    postRequest(
      'genericos/ge/acompanhamentos/Salvar',
      acompanhamento,
      resolve,
      reject
    );
  });
};

const excluirAcompanhamento = (
  CodigoEmpresa: string,
  CodigoOrdemServico: string,
  Seq: number,
  TipoAcompanhamento: string,
  Data: string,
  Hora: string,
  Acao: string,
  EmbarquePedidoOc: string
): Promise<{
  data: [
    {
      tipoAcompanhamento: string;
      empresa: string;
      embarquePedidoOc: string;
      contatoOsLancNf: string;
      sequenciaItem: string;
      codigoTitulo: string;
      data: string;
      hora: string;
      representante: string;
      dataModificacao: string;
      horaModificacao: string;
    }
  ];
}> => {
  return new Promise((resolve, reject) => {
    deleteRequest(
      'genericos/ge/acompanhamentos/Excluir',
      {
        CodigoEmpresa,
        CodigoOrdemServico,
        Seq,
        TipoAcompanhamento,
        Data,
        Hora,
        Acao,
        EmbarquePedidoOc,
      },
      resolve,
      reject
    );
  });
};

const enviarEmail = (
  Para: string,
  Cc: string,
  Cco: string,
  Assunto: string,
  Texto: string,
  Anexos: string,
  LinkGerenciadorDoc: string,
  TextoGerenciadorDoc: string,
  ArquivoCorpoEmailHtml: string
): Promise<any> => {
  return new Promise((resolve, reject) => {
    postRequest(
      'genericos/ge/email/SendEmail',
      {
        Para,
        Cc,
        Cco,
        Assunto,
        Texto,
        Anexos,
        LinkGerenciadorDoc,
        TextoGerenciadorDoc,
        ArquivoCorpoEmailHtml,
      },
      resolve,
      reject
    );
  });
};

export {
  getAcompanhamentos,
  getContatosEmpresa,
  getTituloAcompanhamento,
  hasCredencialEmail,
  montaTituloAcompanhamento,
  salvarContato,
  validarUrl,
  getContatosBloqueados,
  salvarAnexo,
  excluirAnexo,
  criarAcompanhamento,
  excluirAcompanhamento,
  enviarEmail,
};
